module.exports = __webpack_public_path__ + "static/media/mercury-cafe-website.bfc4cc3f.png";